<div class="dynamic-component-wrapper">
  <ng-container #dynamicContainer></ng-container>
</div>